import { render, staticRenderFns } from "./AppointmentTypes.vue?vue&type=template&id=ad3ed86c&"
import script from "./AppointmentTypes.vue?vue&type=script&lang=js&"
export * from "./AppointmentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports